import {BaseUrlService} from './base-url.service';
import {IPromise, IHttpResponse} from 'angular';
import {IFatturaPassivaItem} from '../commons/interfaces/invoices/passive';
import {IResultResponse} from '../commons/interfaces/IResultResponse';

export class FatturaElettronicaPassivaService {
  static $inject: string[] = ['$http', 'BaseUrlService'];

  private baseUrl: any;

  constructor(
    private $http: ng.IHttpService,
    private _baseUrlService: BaseUrlService,
  ) {
    this.baseUrl = _baseUrlService.getBaseUrl();
  }

  getDocuments(filter: any, sortField: string, sortDirection: number): IPromise<IHttpResponse<IResultResponse<IFatturaPassivaItem>>> {
    let _filter: string = encodeURIComponent(JSON.stringify(filter));
    return this.$http.get(`${this.baseUrl}/fattura-elettronica/passiva/get-documents?filter=${_filter}&sortField=${sortField}&sortDirection=${sortDirection}`);
  }

  getDocumentsCsv(filter: any, sortField: string, sortDirection: number): IPromise<IHttpResponse<IResultResponse<IFatturaPassivaItem>>> {
    let _filter: string = encodeURIComponent(JSON.stringify(filter));
    return this.$http.get(`${this.baseUrl}/fattura-elettronica/passiva/get-documents/csv?filter=${_filter}&sortField=${sortField}&sortDirection=${sortDirection}`);
  }

  acceptInvoice(details: any): IPromise<IHttpResponse<any>> {
    return this.$http.put(this.baseUrl + '/fattura-elettronica/passiva/accept-invoice/', details);
  }

  updateProtocol(document: any): IPromise<IHttpResponse<any>> {
    return this.$http.put(this.baseUrl + '/fattura-elettronica/passiva/protocollo/', document);
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/fattura-elettronica-passiva.service.ts